import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";

const logoEnums = {
  APP_ICON: "App Icon",
  LOGO: "Logo",
  SPLASH_SCREEN: "Splash Screen",
};

const UpdateModal = ({
  isUpdateOpen,
  closeUpdateModal,
  uploadAndSaveImg,
  selectedLogoType,
  selectedImgUrl,
}) => {
  const [img, setImg] = useState();
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!img) {
      setError("Image required");
      return;
    }
    uploadAndSaveImg(img, selectedLogoType, "update");
    closeUpdateModal();
  };

  return (
    <Modal show={isUpdateOpen} onHide={closeUpdateModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update {logoEnums[selectedLogoType]}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <img src={selectedImgUrl} className="img-fluid" />
        </div>
        <Input
          label="Image"
          type="file"
          accept="image/png, image/jpeg"
          value={img}
          onChange={(e) => setImg(e.target.files[0])}
        />
        {error && <div className="text-danger">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button text="Save Changes" callBack={handleSave} />
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateModal;
